// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .publicationContainer h1 {
    font-size: 3rem;
    margin-top: 10%;
  }
  .publicationWrapper {
    width: 100%;
  }
  .publicationCard {
    flex-direction: column;
  }
  .cardReverse {
    flex-direction: column;
  }
  .publicationCardContent button {
    width: 100%;
  }
  .infoWrap {
    margin-top: 12px;
  }
  #paperSummary {
    text-align: justify;
  }
}
@media screen and (min-width: 992px) {
  .publicationContainer h1 {
    font-size: 3rem;
  }
  .publicationWrapper {
    width: 80%;
  }
  .publicationCard {
    flex-direction: row;
  }
  .cardReverse {
    flex-direction: row-reverse;
  }
  .publicationCardContent button {
    width: 30%;
  }
  .infoWrap {
    margin-top: 12px;
    margin-left: 28px;
  }
}

.publicationContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: palegreen; */
}
.publicationContainer h1 {
  padding: 24px;
  font-weight: 300;
}
.underLine {
  width: 45%;
  height: 4px;
  margin-top: 12px;
  background-color: #56acb7;
}

.publicationWrapper {
  display: flex;
  flex-direction: column;
  padding: 12px;
}
.publicationCard {
  width: 100%;
  /* background-color: crimson; */
  margin-top: 4%;
  margin-bottom: 4%;
  display: flex;
}
.publicationCardHeader {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* background-color: aliceblue; */
  /* box-shadow: 10px 10px 10px #ddd; */
}
.publicationCardHeader img {
  width: 70%;
  height: 70%;
  object-fit: contain;
}
.thumbnailWrapper {
  display: flex;
  justify-content: center;
  /* background-color: darkcyan; */
  padding: 12px;
  width: 70%;
  height: 20%;
}
.thumbnailWrapper img {
  /* background-color: red; */
  width: 20%;
  border: 1px solid #ccc;
  margin-left: 4px;
  margin-right: 4px;
  cursor: pointer;
}
.publicationCardContent {
  flex: 2;
  padding: 24px;
  /* background-color: orange; */
  display: flex;
  flex-direction: column;
}
#paperSummary {
  color: #777;
}
.publicationCardContent button {
  background-color: #56acb7;
  margin-top: 24px;
  border: none;
  padding: 12px;
}
.publicationCardContent button:hover {
  background-color: #255a61;
}
`, "",{"version":3,"sources":["webpack://./src/components/publication/Publication.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,UAAU;EACV,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,OAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["@media screen and (max-width: 991px) {\n  .publicationContainer h1 {\n    font-size: 3rem;\n    margin-top: 10%;\n  }\n  .publicationWrapper {\n    width: 100%;\n  }\n  .publicationCard {\n    flex-direction: column;\n  }\n  .cardReverse {\n    flex-direction: column;\n  }\n  .publicationCardContent button {\n    width: 100%;\n  }\n  .infoWrap {\n    margin-top: 12px;\n  }\n  #paperSummary {\n    text-align: justify;\n  }\n}\n@media screen and (min-width: 992px) {\n  .publicationContainer h1 {\n    font-size: 3rem;\n  }\n  .publicationWrapper {\n    width: 80%;\n  }\n  .publicationCard {\n    flex-direction: row;\n  }\n  .cardReverse {\n    flex-direction: row-reverse;\n  }\n  .publicationCardContent button {\n    width: 30%;\n  }\n  .infoWrap {\n    margin-top: 12px;\n    margin-left: 28px;\n  }\n}\n\n.publicationContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* background-color: palegreen; */\n}\n.publicationContainer h1 {\n  padding: 24px;\n  font-weight: 300;\n}\n.underLine {\n  width: 45%;\n  height: 4px;\n  margin-top: 12px;\n  background-color: #56acb7;\n}\n\n.publicationWrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n}\n.publicationCard {\n  width: 100%;\n  /* background-color: crimson; */\n  margin-top: 4%;\n  margin-bottom: 4%;\n  display: flex;\n}\n.publicationCardHeader {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  /* background-color: aliceblue; */\n  /* box-shadow: 10px 10px 10px #ddd; */\n}\n.publicationCardHeader img {\n  width: 70%;\n  height: 70%;\n  object-fit: contain;\n}\n.thumbnailWrapper {\n  display: flex;\n  justify-content: center;\n  /* background-color: darkcyan; */\n  padding: 12px;\n  width: 70%;\n  height: 20%;\n}\n.thumbnailWrapper img {\n  /* background-color: red; */\n  width: 20%;\n  border: 1px solid #ccc;\n  margin-left: 4px;\n  margin-right: 4px;\n  cursor: pointer;\n}\n.publicationCardContent {\n  flex: 2;\n  padding: 24px;\n  /* background-color: orange; */\n  display: flex;\n  flex-direction: column;\n}\n#paperSummary {\n  color: #777;\n}\n.publicationCardContent button {\n  background-color: #56acb7;\n  margin-top: 24px;\n  border: none;\n  padding: 12px;\n}\n.publicationCardContent button:hover {\n  background-color: #255a61;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
